import differenceInDays from "date-fns/differenceInDays";
import formatDateStringToObject from "syf-js-utilities/formats/formatDateStringToObject";
var calculateStepperProgress = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate;
    var startDateToEndDateDiff = differenceInDays(formatDateStringToObject(endDate), formatDateStringToObject(startDate)) || 1;
    var startDateToCurrentDateDiff = differenceInDays(new Date(), formatDateStringToObject(startDate)) || 1;
    var stepperExhaustedDays = (startDateToCurrentDateDiff * 100) / startDateToEndDateDiff;
    return stepperExhaustedDays > 100 ? 100 : stepperExhaustedDays;
};
export default calculateStepperProgress;
//# sourceMappingURL=calculateStepperProgress.js.map